import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import NavLinks from './NavLinks2';

function NavPanel(props) {
    const { locale } = props;
    const [scrolled, setScrolled] = useState(false);

    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 140) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    }, []);

    const navbarClasses = ['nav-panel'];
    const logoClasses = ['site-header__logo'];

    if (scrolled) {
        navbarClasses.push('scrolled');
        logoClasses.push('scroll');
    }

    let logo;
    if (locale === 'sq') {
        logo = (
            <div className="site-header__logo-bottom">
                <Link to="/"><img src="/images/logot/arbk_shq.png" alt="" /></Link>
            </div>
        );
    } else if (locale === 'en') {
        logo = (
            <div className="site-header__logo-bottom">
                <Link to="/"><img src="/images/logot/arbk_en.png" alt="" /></Link>
            </div>
        );
    } else if (locale === 'sr') {
        logo = (
            <div className="site-header__logo-bottom">
                <Link to="/"><img src="/images/logot/arbk_sr.png" alt="" /></Link>
            </div>
        );
    }
    return (
        <div className={navbarClasses.join('')}>
            <div className="nav-panel">
                <div className="nav-panel__row">
                    {logo}
                    <div className="nav-panel__nav-links nav-links">
                        <NavLinks layout="default" />
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NavPanel);
